import React, { useRef } from "react";
import auth from "../auth";
import Version from "version";
import { useConnect } from 'dotnetify';

import TopContainer from '../controls/TopContainer';
import { Box, BoxTitle, BoxContent, BoxLink } from '../controls/Box';
import SparkleDialog from '../controls/components/SparkleDialog';
import { Button, Grid } from "@material-ui/core";
import { LargeButton } from '../controls/components/Buttons';

export default function Support() {
    const { state } = useConnect("Support", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        exceptionHandler: _ => auth.signOut()
    });

    const dialogRef = useRef();

    const openUrl = url => {
        dialogRef.current.openUrl(url);
    };
    var supportLinks;
    if (state.IsNorway) {
        supportLinks = [
            { description: 'Ny kunde?', url: 'https://www.chilimobil.no/sporsmal-hjelp/ny-kunde/', icon: 'question', type: 'border' },
            { description: 'Faktura spørsmål', url: 'https://www.chilimobil.no/sporsmal-hjelp/faktura/', icon: 'question', type: 'background' },
            { description: 'EU/EØS og utlandet', url: 'https://www.chilimobil.no/sporsmal-hjelp/mobilabonnement-norge-utlandet/', icon: 'question', type: 'background' },
            { description: 'Mobilhjelp og mobiloppsett', url: 'https://www.chilimobil.no/sporsmal-hjelp/mobilhjelp-og-oppsett/', icon: 'question', type: 'background' },
            { description: 'Dekning og drift', url: 'https://www.chilimobil.no/sporsmal-hjelp/dekning-og-drift/#generell-dekning', icon: 'question', type: 'background' },
            { description: 'Eierskifte', url: 'https://www.chilimobil.no/sporsmal-hjelp/skjema-og-vilkar/#Eierskifteskjema', icon: 'question', type: 'background' },
            { description: 'Familie - informasjon og hjelp', url: 'https://www.chilimobil.no/sporsmal-hjelp/familie/', icon: 'question', type: 'background' },
            { description: 'BankID på mobil', url: 'https://www.chilimobil.no/sporsmal-hjelp/bankid-mobil/', icon: 'question', type: 'background' },
            { description: 'Annet - Spørsmål og hjelp', url: 'https://www.chilimobil.no/sporsmal-hjelp/', icon: 'question', type: 'background' },
        ]
    } else {
        supportLinks = [
            { description: 'Abonnemang', url: 'https://chilimobil.se/support/abonnemang/', icon: 'question', type: 'border' },
            { description: 'Betalning', url: 'https://chilimobil.se/support/betalning/', icon: 'question', type: 'background' },
            { description: 'I utlandet', url: 'https://chilimobil.se/support/i-utlandet/', icon: 'question', type: 'background' },
            { description: 'Leverans', url: 'https://chilimobil.se/support/leverans/', icon: 'question', type: 'background' },
            { description: 'Surfmängd', url: 'https://chilimobil.se/support/surfmangd/', icon: 'question', type: 'background' },
            { description: 'Teknik - Fix & trix', url: 'https://chilimobil.se/support/teknik-fix-trix/', icon: 'question', type: 'background' },
        ]

    };
    return (
        <React.Fragment>
            <SparkleDialog ref={dialogRef} />
            <TopContainer title="Support">
                <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    {supportLinks.map((link, index) => {
                        return (
                            <Box key={index} border={link.type === 'border'} background={link.type === 'background'} linkAction={() => { openUrl(link.url); }}>
                                <BoxLink icon={link.icon} text={link.description} />
                            </Box>
                        )
                    })}
                </Grid>
                <Grid container direction="row" justify="space-between" alignItems="flex-start" style={{ paddingTop: '17px' }}>
                    {state.IsNorway &&
                        <Box background>
                            <BoxTitle>
                                Kundeservice
                            </BoxTitle>
                            <BoxContent>
                                <div style={{ marginLeft: '20px' }}>
                                    Telefon: 915 02 445
                                </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        E-post: kundeservice@chilimobil.no
                                </div>
                                    <div style={{ marginLeft: '20px' }}>
                                        Åpningstider: 09:00-17:00 - Man-fre
                                </div>
                            </BoxContent>
                        </Box>
                    }

                    <Box background>
                        <BoxTitle>
                            {state.IsNorway ? 'Om Chilimobil Min Side' : 'Om Chilimobil MittChili'}
                    </BoxTitle>
                        <BoxContent>
                            {state.IsNorway ? 'Min Side er utviklet av XTS Data AB.' : 'MittChili är utvecklad av XTS Data AB.'}<br />
                            {state.IsNorway ? 'Server versjon:' : 'Server version:'} {state.ServerVersion} {state.IsNorway ? 'Klient versjon:' : 'Klient version'} {state.ClientVersion}
                        </BoxContent>
                    </Box>
                </Grid>
                <LargeButton style={{ marginTop: '27px' }} onClick={() => auth.signOut()}>{state.IsNorway ? 'Logg ut' : 'Logga ut'}</LargeButton>
            </TopContainer>
        </React.Fragment>
    );
}
